import React, { useState } from "react";

const CountryFlag = ({
  value = "",
  height = "13.5px",
  width = "20px",
}: {
  value?: string;
  height?: string;
  width?: string;
}) => {
  const [hasError, setHasError] = useState(false);

  if (hasError) {
    return <div style={{height, width}}></div>;
  }

  return (
    <img
      loading="lazy"
      width={width}
      height={height}
      srcSet={`https://flagcdn.com/w40/${value}.png 2x`}
      src={`https://flagcdn.com/w20/${value}.png`}
      alt={value}
      onError={() => setHasError(true)}
    />
  );
};

export default CountryFlag;
